const testTargetSelector = store => store.testTarget;

export default testTargetSelector;
